import React, { useCallback, useState } from 'react'
import toast from "react-hot-toast";
import classNames from "classnames";

import { CognitoAuthApi } from "../../services/Api/CognitoAuthApi";
import { Label, Input, Button, Loader, WhiteLabel } from "../../components";
import { Sendum } from '../../Sendum';


import classes from "./ForgotPasswordComponent.module.scss";

export const ForgotPasswordComponent = () => {
    const [username, setUsername] = useState<string>("");
    const [isLoading, setLoading] = useState<boolean>(false);
    const [errorInvalidEmail, setErrorInvalidEmail] = useState<boolean>(false);
    const [errorRequiredUsername, setErrorRequiredUsername] = useState<boolean>(false);

    const isValidEmail = useCallback((email: string) => {
        return !(/^[\w\-]{1,}([\w\-\+.]{1,1}[\w\-]{1,}){0,}[@][\w\-]{1,}([.]([\w\-]{1,})){1,}$/.test(email));
    }, []);
    const usernameInputOnChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUsername(event.target.value || "");
    }

    const forgotPasswordButtonOnClickHandler = () => {
        if (isLoading) {
            return;
        }

        const _errorRequiredUsername = !username;
        const _errorInvalidEmail = isValidEmail(username);

        setErrorInvalidEmail(_errorInvalidEmail);
        setErrorRequiredUsername(_errorRequiredUsername);

        if (_errorInvalidEmail || _errorRequiredUsername) {
            return;
        }

        setLoading(true);

        new CognitoAuthApi().forgotPassword(username)
            .then((res) => {
                console.log(res)
                // window.location.href = "/login";
                Sendum.getBrowserHistory().push('/login');
            })
            .catch(error => {
                if (error instanceof Error) {
                    toast.error(error.message);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const returnToLoginOnClickHandler = () => {
        Sendum.getBrowserHistory().push('/login');
    }

    return (
        <div className={classes.forgot}>
            <div className={classes.forgot__column}>
                <WhiteLabel/>
                <div className={classes.forgot__title}>Forgot Password</div>
                <form className={classNames(classes.forgot__form, classes.form)}>
                    {!!isLoading && (<Loader className={classes.form__loading} />)}
                    <div className={classes.form__column}>
                        <Label text={"Enter your e-mail address"} >
                            <Input
                                placeholder={"Email *"}
                                value={username}
                                onChange={usernameInputOnChangeHandler}
                                name={username}
                                autoComplete={"on"}
                                type={"text"}
                            />
                            <>
                                {errorRequiredUsername && (<div className={classes.form__error}>Required</div>)}
                                {!errorRequiredUsername && errorInvalidEmail && <div className={classes.form__error}>Invalid email address</div>}
                            </>
                        </Label>
                        <Button className={classes.form__button} title={"Submit"} onClick={forgotPasswordButtonOnClickHandler} />
                    </div>
                </form>
                <div className={classes.forgot__return} onClick={returnToLoginOnClickHandler}>Return to Login Page</div>
            </div>
        </div>
    )
}